import React from 'react';
import { StatusPill } from './status-pill.jsx';
import { ProgressTinybar } from './progress-bar.jsx';

// Presentational. `model` is the output of programCardModel(). Callbacks:
//   onGenerate(), onPush(), onRedirect(target), onHistory()
export function ProgramCard({ model, onGenerate, onPush, onRedirect, onHistory }) {
  if (!model) return null;
  const m = model;
  const tone = m.program === 'bhi' ? 'bhi' : 'ccm';

  return (
    <div className={`program-card program-card-${tone} program-card-${m.variant}`}>
      <div className="program-card-head">
        <span className={`program-badge program-badge-${tone}`}>{m.label || m.code}</span>
        {m.statusPill
          ? <StatusPill status={m.statusPill} sm />
          : m.statusChip
            ? <span className={`program-status-chip ${m.statusChip.tone}`}>{m.statusChip.label}</span>
            : null}
      </div>

      {m.timeText ? <div className="program-card-time tabnum">{m.timeText}</div> : null}
      {m.showProgress ? <ProgressTinybar value={m.progress.value} target={m.progress.target} /> : null}

      {m.blockers && m.blockers.length > 0 && (
        <ul className="program-card-blockers">
          {m.blockers.map((b, i) => <li key={i}><span aria-hidden="true">⚠ </span>{b}</li>)}
        </ul>
      )}

      {m.foldedHint ? <div className="program-card-hint">{m.foldedHint}</div> : null}

      {m.genError ? (
        <div className="program-card-gen-error" role="alert"
          style={{ color: 'var(--warn)', fontSize: 12, marginTop: 6 }}>
          <span aria-hidden="true">⚠ </span>
          Generate failed{m.genError.message ? `: ${m.genError.message}` : ''}. Click Generate to retry.
        </div>
      ) : null}

      {(m.primaryAction || m.secondaryAction) && (
        <div className="program-card-actions">
          {m.primaryAction && (
            <button
              className={`btn sm accent program-action-${tone}`}
              disabled={m.primaryAction.disabled}
              title={m.primaryAction.title}
              onClick={() => onGenerate?.()}>
              {m.primaryAction.busy ? 'Generating…' : m.primaryAction.label}
            </button>
          )}
          {m.secondaryAction && (
            <button
              className={`btn sm accent program-action-${tone}`}
              disabled={m.secondaryAction.disabled}
              title={m.secondaryAction.title}
              onClick={() => onPush?.()}>
              {m.secondaryAction.busy ? 'Pushing…' : m.secondaryAction.label}
            </button>
          )}
        </div>
      )}

      {m.assessmentText ? (
        <div className="program-card-assessment">
          {m.assessmentText}
          {m.showHistory && <button className="link-btn" onClick={() => onHistory?.()}>History →</button>}
        </div>
      ) : null}

      {m.redirect ? (
        <button className="btn sm program-card-redirect" onClick={() => onRedirect?.(m.redirect.target)}>
          {m.redirect.label}
        </button>
      ) : null}
    </div>
  );
}
